// extracted by mini-css-extract-plugin
module.exports = {"trigger":"tabs-featured_trigger__8u5Wl","triggerLabel":"tabs-featured_triggerLabel__K0yUl","tabs":"tabs-featured_tabs__ECbxg"};